<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import * as Icons from '@ant-design/icons-vue'
import type { MenuItem } from '@/types/menu'
import { useRouter } from 'vue-router'

const props = defineProps<{
  item: MenuItem
}>()

const { t } = useI18n()
const router = useRouter()

// 获取图标组件
function getIcon(iconName?: string) {
  if (!iconName) return null
  return (Icons as Record<string, any>)[iconName]
}

// 获取菜单标题（支持多语言）
function getMenuTitle(title?: string) {
  if (!title) return ''
  // 如果是多语言键，则翻译；否则直接返回
  return title.startsWith('router.') ? t(title) : title
}

// 判断是否为叶子节点
const isLeaf = !props.item.children || props.item.children.length === 0

// 处理菜单点击
function handleMenuClick(path: string) {
  if (isLeaf) {
    router.push(path)
  }
}
</script>

<template>
  <!-- 无子菜单的项 -->
  <a-menu-item 
    v-if="isLeaf" 
    :key="item.path" 
    @click="() => handleMenuClick(item.path)"
  >
    <template #icon>
      <component :is="getIcon(item.meta.icon)" v-if="item.meta.icon" />
    </template>
    <span>{{ getMenuTitle(item.meta.title) }}</span>
  </a-menu-item>

  <!-- 有子菜单的项 -->
  <a-sub-menu v-else :key="item.path">
    <template #icon>
      <component :is="getIcon(item.meta.icon)" v-if="item.meta.icon" />
    </template>
    <template #title>{{ getMenuTitle(item.meta.title) }}</template>
    
    <!-- 递归渲染子菜单 -->
    <SidebarItem 
      v-for="child in item.children" 
      :key="child.path" 
      :item="child" 
    />
  </a-sub-menu>
</template>
